import React, { useState } from 'react';

import { useRecoilValue } from 'recoil';

import { iaRa } from 'lib/helpers/utility';
import { useDocumentSign } from 'lib/hooks/queries/documentSign/useDocumentSign';

import Button from 'components/shared/Buttons/Button';
import { userState } from 'components/state';

import SignModal from '../../shared/Sign/SignModal';

const SignButton = ({ itemPropsId, activeView, actionViews }) => {
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);

  const user = useRecoilValue(userState);

  const { data: documentData } = useDocumentSign({
    params: {
      documentIds: [itemPropsId],
      documentTypes: [activeView?.type === 'referral' ? 'referral_order' : activeView?.type],
      withRelations: { user: true }
    },
    dependencies: [itemPropsId],
    options: {
      refetchOnMount: false,
      enabled: activeView.component === 'preview' && !!itemPropsId,
      select: (response) => {
        const currentUserDocument = iaRa(response?.data).find((row) => row.user_id == user.id);

        return {
          hasSigned: currentUserDocument?.status === 'signed',
          isUserAssigned: !!currentUserDocument
        };
      }
    }
  });

  if (!(!documentData?.hasSigned && documentData?.isUserAssigned)) return null;

  return (
    <>
      <Button
        text="Sign"
        icon="lock-2-opened-linear"
        type="secondary"
        className="!ml-4"
        onClick={() => setShowConfirmationModal(true)}
      />
      {itemPropsId && (
        <SignModal
          documentId={itemPropsId}
          documentTypes={[actionViews?.type]}
          setShowConfirmationModal={setShowConfirmationModal}
          showConfirmationModal={showConfirmationModal}
          confirmModalProps={{
            title: 'Sign Referral Order',
            message: 'Are you sure you want to sign this referral order',
            primaryBtnTxt: 'Sign referral order'
          }}
        />
      )}
    </>
  );
};

export default SignButton;
